import React, { useState } from 'react';
import { StaticImage } from "gatsby-plugin-image";
import axios from 'axios';
import * as emailFormStyles from './emailForm.module.scss'
import { OutboundLink } from 'gatsby-plugin-google-gtag';

const EmailForm = () => {
    const [status, setStatus] = useState(null);
    const [subEmail, setSubEmail] = useState('');
    const [subName, setSubName] = useState('');
    let error = ''
    const FORM_URL = `/api/subscribe`;
    const handleSubmit = async (e) => {
        e.preventDefault();
        let newSubscriber = {
            name: subName,
            email: subEmail,
            resubscribe: true
        }
        const data = newSubscriber;
        const options = {
            url: FORM_URL,
            method: 'POST',
            data
        }
        try {
            const response = await axios(
                options
            );
            setSubName('');
            setSubEmail('');
            if (response.status === 200) {
                setStatus('SUCCESS');
                return;
            }
        } catch (err) {
            setStatus('ERROR');
            console.log(err);
            error = err;
        }
    };

    const handleEmailChange = event => {
        const {value} = event.target;
        setSubEmail(value);
    }

    const handleNameChange = event => {
        const {value} = event.target;
        setSubName(value);
    }

    return (
        <div className={emailFormStyles.subscriberBox}>
            <StaticImage
                    className={emailFormStyles.subscriberBanner}
                    src="../images/YTCover.jpg"
                    alt="Four vegan dishes: Creme Brulee, Detroit-style pizza, General Tso's Tofu, and Lemon Tart" />
            <div className={emailFormStyles.subscriberBoxInner}>
            {status === 'SUCCESS' ? <div>
                <h2 className={emailFormStyles.subscriberHeading}>Thank you!</h2>
                <p className={emailFormStyles.subscriberText}>and welcome to our little vegan community! If you don't receive an email within 15 minutes, please email me at <OutboundLink href="mailto:steph@stephsunshine.com">steph@stephsunshine.com</OutboundLink>.</p> 
                </div>: 
            <div>
                <h2 className={emailFormStyles.subscriberHeading}>Vegan recipes in your inbox</h2>
            <p className={emailFormStyles.subscriberText}>
                Join the community and get my newest and best yummy vegan recipes sent right to your email! 
            </p>

            
            
            <form
                action={FORM_URL}
                method="post"
                onSubmit={handleSubmit}
            >
                <div className={emailFormStyles.subscriberInputGroup}>
                <input
                    className={emailFormStyles.subscriberInput}
                    type="name"
                    aria-label="Your name"
                   //The name attribute should be the same as on you selected form.
                    name="name"
                    placeholder="Name"
                    onChange={handleNameChange}
                    value={subName}
                    required
                />
                <input
                    className={emailFormStyles.subscriberInput}
                    type="email"
                    aria-label="Your email"
                   //The name attribute should be the same as on you selected form.
                    name="email"
                    placeholder="Email"
                    onChange={handleEmailChange}
                    value={subEmail}
                    required
                />
            
                
                
                <button type="submit" className={`btn-color ${emailFormStyles.subscriberButton}`}>
                    Sign me up!
                </button>
                </div>
                <div className={emailFormStyles.subscriberBottom}>
                <div className={emailFormStyles.subscriberCheckGroup}>
                <input 
                    className={emailFormStyles.subscriberCheck}
                    type="checkbox"
                    aria-label="consent"
                    name="consent"
                    required
                />
                <label htmlFor="consent" className={emailFormStyles.subscriberText}>Yes, it's okay to email me!</label>
                </div>
                {status === 'ERROR' && <p className={emailFormStyles.subscriberError}>Oops, Something went wrong! {error}</p>}
                </div>
            </form>
            
            </div>  }
            </div>
        </div>
    );
};

export default EmailForm